import { Navigate, useRoutes } from "react-router-dom";
import ThreadByIDShared from "src/micro/Chat/ThreadByIDShared";
import LoginView from "src/micro/utils/LoginView";

export default function UnAuthRouter() {
  return useRoutes([
    {
      path: "/",
      children: [
        {
          element: <LoginView />,
          index: true,
        },
        { path: ":id", element: <ThreadByIDShared /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
